module.exports = __webpack_public_path__ + "static/media/first-access-illustration.484a98c9.png";